import { RouteConfig } from 'vue-router';

import RouterView from '@/components/layout/Router.vue';
import { settingAddRoute } from './setting/add.route';
import { settingEditRoute } from './setting/edit.route';
import { settingsRoute } from './setting/settings.route';

export const settingsContainerRoute: RouteConfig = {
  path: 'settings/:groupId?',
  component: RouterView,
  children: [settingAddRoute, settingEditRoute, settingsRoute],
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'breadcrumbs.settings.list',
      name: 'settings'
    },
    config: {
      title: 'menu.settings',
      name: 'settings',
      icon: 'fa-cog',
      permissions: ['SETTING.LIST'],
      group: 'Ustawienia'
    }
  }
};
